import React from "react";
import { ContactUsHeroWrap } from "./ContactUsHero.styled";

const ContactUsHero = () => {
  return (
    <ContactUsHeroWrap>
      <div>
        <h2>Contact Us</h2>
      </div>
    </ContactUsHeroWrap>
  );
};

export default ContactUsHero;
